import React from 'react';
import { useConfig } from '../hooks/useConfig';
import './MascotMessage.css';

/**
 * MascotMessage Component
 * Displays mascot with speech bubble message
 */
function MascotMessage({
  message,
  state = 'idle',
  size = 'medium',
  position = 'left',
  animate = true
}) {
  const { config } = useConfig();
  const mascotConfig = config?.mascot;

  // Show a fallback if mascot is not configured yet
  if (!mascotConfig) {
    return (
      <div className={`mascot-message ${size}`} data-state={state}>
        <div className="mascot-avatar">
          <span style={{ fontSize: '48px' }}>🐍</span>
        </div>
        {message && (
          <div className="mascot-speech-bubble">
            {config?.app?.name && <div className="mascot-name">{config.app.name}</div>}
            <p className="mascot-message-text">{message}</p>
          </div>
        )}
      </div>
    );
  }

  // Check if mascot is enabled
  if (!mascotConfig.enabled) return null;

  const getMascotSrc = () => {
    const stateFile = mascotConfig.states?.[state] || mascotConfig.states?.idle || 'mascot.svg';
    return `/assets/media/${mascotConfig.basePath}/${stateFile}`;
  };

  return (
    <div className={`mascot-message ${size}`} data-state={state}>
      <div className={`mascot-avatar ${animate ? 'animate' : ''}`}>
        <img
          src={getMascotSrc()}
          alt={mascotConfig.name || 'Mascot'}
          onError={(e) => {
            // Fallback to emoji on image load error
            e.target.style.display = 'none';
            e.target.parentElement.innerHTML = '<span style="font-size: 48px">🐍</span>';
          }}
        />
      </div>
      
      {message && (
        <div className="mascot-speech-bubble">
          {mascotConfig.name && <div className="mascot-name">{mascotConfig.name}</div>}
          <p className="mascot-message-text">{message}</p>
        </div>
      )}
    </div>
  );
}

export default MascotMessage;